import Vue from 'vue';

export const purchaseOrderDetailsService = {
  async retrievePurchaseOrder(referenceNumber) {
    return Vue.axios.get(`/purchase-orders/${referenceNumber}`).then(response => response.data);
  },

  async saveItemDetails(poItemDetails) {
    return Vue.axios
      .post(`/purchase-orders/update-funds/${poItemDetails.poRefNum}`, {
        params: {
          ...poItemDetails
        }
      })
      .then(response => response.data);
  },

  async saveNewItem(newLineItemDetails) {
    return Vue.axios
      .post(`/purchase-orders/save/lineitem/${newLineItemDetails.poRefNum}`, {
        params: {
          ...newLineItemDetails
        }
      })
      .then(response => response.data);
  },

  async savePurchaseOrder(poData) {
    return Vue.axios
      .post(`/purchase-orders/${poData.reference_number}`, {
        params: {
          ...poData
        }
      })
      .then(response => response.data);
  },

  async retrievePOHistories(referenceNumber) {
    return Vue.axios
      .get(`/purchase-orders/${referenceNumber}/history`)
      .then(response => response.data);
  },

  async retrievePOFullAuditTrial(referenceNumber, filteredItemNo) {
    return Vue.axios
      .get(`/purchase-orders/${referenceNumber}/full-audit-trial?filterItem=${filteredItemNo}`)
      .then(response => response.data);
  },
  async retrievePOAssignments(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/purchase-orders/${referenceNumber}/assignments`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  },
  async retrievePOPreviousAssignments(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/purchase-orders/${referenceNumber}/previous-assignments`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  }
};
